import { DataGrid, } from '@mui/x-data-grid';
import { useState } from 'react';

const DataTable = ({ rows, columns }: any) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    return (
        <>
            <div style={{ height: 'auto', width: '100%' }}>
                <DataGrid rows={rows} columns={columns}
                    // pagination
                    autoHeight
                    hideFooterPagination={true}
                    // paginationModel={paginationModel}
                    // onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
                    // pageSizeOptions={[10, 25, 50]} // Provide page size options as needed
                    paginationMode="client"  // Ensure pagination mode is set to client
                />
            </div>
        </>
    )
}

export default DataTable;